import { Button } from '@mui/material';

import { useTranslate } from 'src/locales';

import { ConfirmDialog } from 'src/components/custom-dialog';

type Props = {
  open: boolean;
  /** Bulk add: how many of the chosen candidates have no profile. Omit for a single candidate. */
  count?: number;
  onBuild: VoidFunction;
  onSkip: VoidFunction;
  /** Back to the add dialog, adding nobody. */
  onClose: VoidFunction;
};

/**
 * Asked when a recruiter adds a candidate with an empty profile straight into Screening (JT1-1821).
 * Reaching Screening later builds the profile on its own; going straight in skips that, so the
 * recruiter chooses here.
 */
export default function BuildProfilePrompt({ open, count, onBuild, onSkip, onClose }: Props) {
  const { t } = useTranslate();

  const key = 'candidates.invites.add_to_job_modal.build_profile_prompt';

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={t(`${key}.title`)}
      content={count === undefined ? t(`${key}.content`) : t(`${key}.content_bulk`, { count })}
      action={
        <>
          <Button variant="outlined" onClick={onSkip}>
            {t(`${key}.skip`)}
          </Button>
          <Button variant="contained" onClick={onBuild}>
            {t(`${key}.build`)}
          </Button>
        </>
      }
    />
  );
}
